import propTypes from "prop-types";
import { palette } from "../styles";

const FarmersBranchLogo = ({
  width,
  height,
  className,
  color,
  ...allProps
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      {...allProps}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 80 48.223"
    >
      <g transform="translate(0)">
        <path
          d="M75.945,17.37,46.011,1.5a12.828,12.828,0,0,0-12.021,0L4.056,17.37a7.631,7.631,0,0,0,0,13.483L33.99,46.728a12.829,12.829,0,0,0,12.021,0L75.945,30.853a7.631,7.631,0,0,0,0-13.483M8.67,26.142a2.03,2.03,0,1,1,2.03-2.03,2.03,2.03,0,0,1-2.03,2.03m27.584,9.285h-3.04V17.663h8.558a1.52,1.52,0,1,1,0,3.04H36.253v6.841H41.8a1.52,1.52,0,1,1,0,3.04H36.253Zm12.631-6.418q0,.141-.006.281a6.377,6.377,0,0,1-5.627,5.992,18.865,18.865,0,0,1-2.337.145h-2.48v-3.04h3.694a3.378,3.378,0,0,0,0-6.755H38.434v-3.04h3.694a3.378,3.378,0,0,0,0-6.755h-8.91V12.8h7.7a18.865,18.865,0,0,1,2.337.145,6.377,6.377,0,0,1,5.627,5.992q.006.14.006.281a6.738,6.738,0,0,1-2.107,4.9,6.738,6.738,0,0,1,2.107,4.9m22.447-2.868a2.03,2.03,0,1,1,2.03-2.03,2.03,2.03,0,0,1-2.03,2.03"
          transform="translate(0)"
          fill={color}
        />
      </g>
    </svg>
  );
};

FarmersBranchLogo.propTypes = {
  width: propTypes.number,
  height: propTypes.number,
  className: propTypes.string,
  color: propTypes.string,
};

FarmersBranchLogo.defaultProps = {
  width: 80,
  height: 48.223,
  color: palette.primary,
};

export { FarmersBranchLogo };
